/**
 * AuthShell — split-screen auth layout (design: "Kirish · Ro'yxat" artboard).
 *
 * Left: coral-tint visual panel with slogan, avatars and the hex
 * constellation (hidden on mobile). Right: centered form column.
 */
import { Link } from 'react-router-dom'
import { Logo, Hex, Avatar } from '@/components/kit'
import {
  BookOpen, FileText, Users, BarChart3, Star, Trophy,
  Pencil, Heart, Sparkles,
} from 'lucide-react'

const HEX_DECOR = [
  ['coral', BookOpen], ['butter', FileText], ['mint', Users],
  ['lav', BarChart3], ['sky', Star], ['pink', Trophy],
  ['coral', Pencil], ['mint', Heart], ['butter', Sparkles],
]

export default function AuthShell({ children }) {
  return (
    <div className="min-h-screen flex" style={{ background: 'var(--bg)', color: 'var(--ink)' }}>
      {/* Left visual */}
      <div className="hidden lg:flex" style={{
        flex: 1, background: 'var(--coral-tint)',
        padding: 48, flexDirection: 'column', justifyContent: 'space-between',
        position: 'relative', overflow: 'hidden',
      }}>
        <Link to="/" style={{ textDecoration: 'none', zIndex: 1 }}><Logo size={32} /></Link>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 className="h-display" style={{ fontSize: 44, lineHeight: 1.1, margin: 0, letterSpacing: '-0.02em' }}>
            Bilim — <br />siz o'lchaydigan <br />narsa<span style={{ color: 'var(--coral)' }}>.</span>
          </h1>
          <p className="t-md" style={{ color: 'var(--ink-2)', marginTop: 16, maxWidth: 360 }}>
            5 daqiqada imtihon yarating yoki ishlang — natijasi sizniki.
          </p>
        </div>
        <div className="row gap-12" style={{ zIndex: 1 }}>
          {['Aziza K.', 'Bekzod R.', 'Madina T.', 'Sherzod O.'].map((n, i) => (
            <Avatar key={n} name={n} size={32} idx={i} />
          ))}
          <span className="t-sm t-mut">+ 12 000 talaba</span>
        </div>
        {/* Hex decoration */}
        <div style={{
          position: 'absolute', top: 100, right: -60,
          display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8, opacity: 0.7,
        }}>
          {HEX_DECOR.map(([c, I], i) => (
            <Hex key={i} size="md" icon={I} bg={`var(--${c}-soft)`} fg={`var(--${c})`} />
          ))}
        </div>
      </div>

      {/* Right form */}
      <div style={{ flex: 1, background: 'var(--surface)', display: 'grid', placeItems: 'center', padding: '48px 24px' }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          <div className="lg:hidden" style={{ marginBottom: 24 }}>
            <Link to="/" style={{ textDecoration: 'none' }}><Logo size={28} /></Link>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

/* Shared labelled input for auth forms */
export function AuthInput({ label, rightLabel, ...rest }) {
  return (
    <label className="block">
      <span className="row" style={{ justifyContent: 'space-between', marginBottom: 6 }}>
        <span className="t-xs fw-6">{label}</span>
        {rightLabel}
      </span>
      <input className="input" {...rest} />
    </label>
  )
}
